import { render, staticRenderFns } from "./CouponCodeList.vue?vue&type=template&id=048b9c25"
import script from "./CouponCodeList.vue?vue&type=script&lang=ts"
export * from "./CouponCodeList.vue?vue&type=script&lang=ts"
import style0 from "./CouponCodeList.vue?vue&type=style&index=0&id=048b9c25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports